export default "__VITE_ASSET__C5zWxP7H__"